import { render } from "./OnboardingQuicktrialLayout.vue?vue&type=template&id=040b93fe&scoped=true"
import script from "./OnboardingQuicktrialLayout.vue?vue&type=script&lang=js"
export * from "./OnboardingQuicktrialLayout.vue?vue&type=script&lang=js"

import "./OnboardingQuicktrialLayout.vue?vue&type=style&index=0&id=040b93fe&lang=scss&scoped=true"
import "./OnboardingQuicktrialLayout.vue?vue&type=style&index=1&id=040b93fe&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040b93fe"]])

export default __exports__